import { Popover } from "@mui/material";

/**
 * Dropdown Popover Component
 * @param {Object} props
 * @param {String} id Dropdown id
 * @param {Boolean} open
 * @param {Element} anchorEl Dropdown anchor element
 * @param {Element} children Popover children
 * @param {Function} onClose Function to execute on dropdown close
 * @returns JSX.Element
 */
export const DropdownPopover = ({ id, open, anchorEl, children, onClose, PaperProps, ...props }) => {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      {...props}
      slotProps={{
        paper: {
          id: `${id}-paper`,
          ...PaperProps,
        }
      }}>
      {children}
    </Popover>
  );
};
